import { Button } from "antd";
import styled from "styled-components";

export const CloseBtnStyle = styled(Button)`
  position: absolute;
  right: ${(props) => props.$paddingHorizon ?? 0}px;
`;
